export enum UserRole {
  ROLE_MDV = 'ROLE_MDV',
  ROLE_MDT = 'ROLE_MDT',
}
